/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import { getLabelValue } from '@tcp/core/src/utils';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import MyPrefrence from '../views';
import {
  getSmsPhone,
  getGymSmsPhone,
  getSnjSmsPhone,
  getPjpSmsPhone,
  getTcpSubscribe,
  getTcpAppSubscribe,
  getGymSubscribe,
  getSnjSubscribe,
  getPjpSubscribe,
  getGymAppSubscribe,
  getSnjAppSubscribe,
  getPjpAppSubscribe,
  getshowNotification,
} from './MyPreferenceSubscription.selectors';
import { getUserPhoneNumber } from '../../User/container/User.selectors';
import MyPreferenceSubscribeModal from '../organism/TcpSubscribeModal/MyPreferenceSubscribeModal.view';
import MyPreferenceAppSubscribeModal from '../organism/TcpAppSubscribeModal/MyPreferenceAppSubscribeModal.view';
import MyPreferenceUnsubscribeModal from '../organism/TcpUnsubscribeModal/MyPreferenceUnsubscribeModal.view';
import MyPreferenceAppUnsubscribeModal from '../organism/TcpAppUnsubscribeModal/MyPreferenceAppUnsubscribeModal.view';
import {
  getSubscribeStore,
  setBrandSubscribeData,
  subscribeFailureReset,
} from './MyPreferenceSubscription.actions';
import MyPreferenceSubscriptionConstants from '../MyPreferenceSubscription.constants';
import MyPreferenceSubscriptionReducer from './MyPreferenceSubscription.reducer';
import { SubscribeStoreSaga } from './MyPreferenceSubscription.saga';
import {
  getIsSnjPjpCheckboxesDisabled,
  getNewGlobalErrorMessage,
} from '../../../../../reduxStore/selectors/session.selectors';
import GlobalErrorComponentReducer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import { setGlobalError } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.actions';
import { getErrorVisibleState } from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.selectors';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import MyPreferenceSubscriptionLabels, {
  ACCOUNT_PREFERENCES,
} from '../views/MyPreferenceSubscription.labels';

export class MyPreferenceSubscription extends PureComponent {
  constructor(props) {
    super(props);
    const { labels, ...otherProps } = this.props;
    this.initialValuesPreference = this.getPreferenceInitialValues(otherProps);
    this.initialValuesSubscribe = this.getSubscribeInitialValues(otherProps);
    this.state = {
      modalVisible: false,
      activeModal: '',
    };
    this.myPreferenceLabels = getLabelFromCopyOrFromTranslation(
      ACCOUNT_PREFERENCES,
      MyPreferenceSubscriptionLabels
    );
  }

  componentDidMount() {
    const { getSubscribeStoreAction } = this.props;
    getSubscribeStoreAction();
  }

  componentDidUpdate(prevProps) {
    const { setGlobalErrorAction, isErrorVisibleState } = this.props;
    if (isErrorVisibleState !== prevProps.isErrorVisibleState && isErrorVisibleState) {
      const errMsg = renderLabel(this.myPreferenceLabels?.phone_not_eligible, 'phone_not_eligible');
      setGlobalErrorAction({ message: errMsg, type: 'error' });
    }
  }

  /**
   * This function use for view Earn Activity details for Earn Activity modal
   * can be passed in the component.
   * @param earnActivity - this is earnActivity data used for show Activity details
   */
  handlePopupSubscribeModal = () => {
    this.setState({
      modalVisible: false,
      activeModal: '',
    });
  };

  getPreferenceInitialValues = (props) => {
    const { tcpWebSubscribe } = props;
    return { tcpWebSubscribe };
  };

  getSubscribeInitialValues = (props) => {
    const { phoneNumber } = props;
    return { phoneNumber };
  };

  getModalAriaLabel = (activeModal, labels) => {
    switch (activeModal) {
      case MyPreferenceSubscriptionConstants.TCP_WEB_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_subscribe_text_alerts');
      case MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_preference_push_notification_heading');
      case MyPreferenceSubscriptionConstants.TCP_WEB_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_modal_unsubscribe_title');
      case MyPreferenceSubscriptionConstants.TCP_APP_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_preference_push_unsubscribe_heading');
      case MyPreferenceSubscriptionConstants.GYMBOREE_WEB_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_subscribe_text_alerts');
      case MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_preference_push_notification_heading');
      case MyPreferenceSubscriptionConstants.GYMBOREE_WEB_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_modal_unsubscribe_title');
      case MyPreferenceSubscriptionConstants.GYMBOREE_APP_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_preference_push_unsubscribe_heading');
      case MyPreferenceSubscriptionConstants.SNJ_WEB_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_subscribe_text_alerts');
      case MyPreferenceSubscriptionConstants.SNJ_WEB_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_modal_unsubscribe_title');
      case MyPreferenceSubscriptionConstants.PJP_WEB_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_subscribe_text_alerts');
      case MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE:
        return getLabelValue(labels, 'lbl_preference_push_notification_heading');
      case MyPreferenceSubscriptionConstants.PJP_WEB_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_prefrence_modal_unsubscribe_title');
      case MyPreferenceSubscriptionConstants.PJP_APP_UNSUBSCRIBE:
        return getLabelValue(labels, 'lbl_preference_push_unsubscribe_heading');
      default:
        return null;
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  handleSubmitModalPopup = (data) => {
    const { activeModal } = this.state;
    const { submitSubscribeBrand, smsPhone, gymSmsPhone, snjSmsPhone, pjpSmsPhone } = this.props;
    let formSubscribeData = {};

    if (activeModal === MyPreferenceSubscriptionConstants.TCP_WEB_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_TCP,
        mobileNumber: data.phoneNumber,
        CustomerPreferences: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.MARKETING_PREFERENCE_SMS,
            isModeSelected: true,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_TCP,
        mobileNumber: smsPhone,
        CustomerPreferences: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.TCP_WEB_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_TCP,
        mobileNumber: smsPhone,
        CustomerPreferences: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.MARKETING_PREFERENCE_SMS,
            isModeSelected: false,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.TCP_APP_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_TCP,
        mobileNumber: smsPhone,
        CustomerPreferences: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_WEB_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_GYMBOREE,
        mobileNumber: data.phoneNumber,
        CustomerPreferencesGym: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.GYMBOREE_MARKETING_PREFERENCE_SMS,
            isModeSelected: true,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_GYMBOREE,
        mobileNumber: gymSmsPhone,
        CustomerPreferencesGym: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_WEB_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_GYMBOREE,
        mobileNumber: gymSmsPhone,
        CustomerPreferencesGym: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.GYMBOREE_MARKETING_PREFERENCE_SMS,
            isModeSelected: false,
          },
        ],
      };
    }

    if (activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_APP_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_GYMBOREE,
        mobileNumber: gymSmsPhone,
        CustomerPreferencesGym: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.SNJ_APP_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_SNJ,
        mobileNumber: snjSmsPhone,
        CustomerPreferencesSnj: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.SNJ_APP_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_SNJ,
        mobileNumber: snjSmsPhone,
        CustomerPreferencesSnj: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_PJP,
        mobileNumber: pjpSmsPhone,
        CustomerPreferencesPjp: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.PJP_APP_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_PJP,
        mobileNumber: pjpSmsPhone,
        CustomerPreferencesPjp: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_PUSH,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.SNJ_WEB_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_SNJ,
        mobileNumber: data.phoneNumber,
        CustomerPreferencesSnj: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.SNJ_MARKETING_PREFERENCE_SMS,
            isModeSelected: true,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.SNJ_WEB_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_SNJ,
        mobileNumber: snjSmsPhone,
        CustomerPreferencesSnj: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.GYMBOREE_MARKETING_PREFERENCE_SMS,
            isModeSelected: false,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.PJP_WEB_SUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_PJP,
        mobileNumber: data.phoneNumber,
        CustomerPreferencesPjp: [
          {
            isModeSelected: true,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.PJP_MARKETING_PREFERENCE_SMS,
            isModeSelected: true,
          },
        ],
      };
    }
    if (activeModal === MyPreferenceSubscriptionConstants.PJP_WEB_UNSUBSCRIBE) {
      formSubscribeData = {
        brand: MyPreferenceSubscriptionConstants.BRAND_PJP,
        mobileNumber: pjpSmsPhone,
        CustomerPreferencesPjp: [
          {
            isModeSelected: false,
            preferenceMode: MyPreferenceSubscriptionConstants.PLACE_REWARDS_SMS,
          },
          {
            preferenceMode: MyPreferenceSubscriptionConstants.PJP_MARKETING_PREFERENCE_SMS,
            isModeSelected: false,
          },
        ],
      };
    }
    submitSubscribeBrand(formSubscribeData);
    this.handlePopupSubscribeModal();
  };

  /**
   * @function onSelectStore function to handle the toggling og checkbox
   * @param {object} event - event object
   */
  onSubscribe = (subscribeBrand) => {
    if (subscribeBrand === MyPreferenceSubscriptionConstants.TCP_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.TCP_WEB_SUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.GYMBOREE_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.GYMBOREE_WEB_SUBSCRIBE,
      });
    }
    if (subscribeBrand === MyPreferenceSubscriptionConstants.SNJ_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.SNJ_WEB_SUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.PJP_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.PJP_WEB_SUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.SNJ_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.SNJ_APP_SUBSCRIBE,
      });
    }
    if (subscribeBrand === MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE,
      });
    }
    return true;
  };

  onUnsubscribe = (subscribeBrand) => {
    if (subscribeBrand === MyPreferenceSubscriptionConstants.TCP_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.TCP_WEB_UNSUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.GYMBOREE_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.GYMBOREE_WEB_UNSUBSCRIBE,
      });
    }
    if (subscribeBrand === MyPreferenceSubscriptionConstants.SNJ_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.SNJ_WEB_UNSUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.PJP_WEB_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.PJP_WEB_UNSUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.TCP_APP_UNSUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.GYMBOREE_APP_UNSUBSCRIBE,
      });
    }

    if (subscribeBrand === MyPreferenceSubscriptionConstants.SNJ_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.SNJ_APP_UNSUBSCRIBE,
      });
    }
    if (subscribeBrand === MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE) {
      this.setState({
        modalVisible: true,
        activeModal: MyPreferenceSubscriptionConstants.PJP_APP_UNSUBSCRIBE,
      });
    }
    return true;
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      labels,
      handleComponentChange,
      componentProps,
      router,
      isSnjSubscribe,
      isPjpSubscribe,
      isTcpSubscribe,
      isGymSubscribe,
      isTcpAppSubscribe,
      isGymAppSubscribe,
      isSnjAppSubscribe,
      isPjpAppSubscribe,
      phoneNumber,
      smsPhone,
      snjSmsPhone,
      gymSmsPhone,
      pjpSmsPhone,
      trackSubscriptionEvent,
      isSnjPjpBrandCheckboxesDisabled,
      showNotification,
      subscribeFailureResetAction,
      newGlobalErrorMessageEnabled,
    } = this.props;
    const { modalVisible, activeModal } = this.state;
    const modalAriaLabel = this.getModalAriaLabel(activeModal, labels);
    const urlParams = router.query || {};
    // BRAND-SPECIFIC-TODO
    return (
      <>
        <MyPrefrence
          labels={labels}
          handleComponentChange={handleComponentChange}
          componentProps={componentProps}
          isTcpSubscribe={isTcpSubscribe}
          isTcpAppSubscribe={isTcpAppSubscribe}
          isSnjAppSubscribe={isSnjAppSubscribe}
          isPjpAppSubscribe={isPjpAppSubscribe}
          showNotification={showNotification}
          subscribeFailureResetAction={subscribeFailureResetAction}
          isGymSubscribe={isGymSubscribe}
          isSnjSubscribe={isSnjSubscribe}
          isPjpSubscribe={isPjpSubscribe}
          isGymAppSubscribe={isGymAppSubscribe}
          initialValues={this.initialValuesPreference}
          onSubscribe={this.onSubscribe}
          onUnsubscribe={this.onUnsubscribe}
          trackSubscriptionEvent={trackSubscriptionEvent}
          urlParams={urlParams}
          isSnjPjpBrandCheckboxesDisabled={isSnjPjpBrandCheckboxesDisabled}
          newGlobalErrorMessageEnabled={newGlobalErrorMessageEnabled}
        />
        {modalVisible && (
          <Modal
            isOpen={modalVisible}
            onRequestClose={this.handlePopupSubscribeModal}
            overlayClassName="TCPModal__Overlay"
            className="TCPModal__Content"
            maxWidth="457px"
            fixedWidth
            heading={''}
            standardHeight
            horizontalBar={false}
            contentLabel={modalAriaLabel}
            closeIconDataLocator="ExtraPointsDetailModal_crossIcon"
          >
            {(activeModal === MyPreferenceSubscriptionConstants.TCP_WEB_SUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_WEB_SUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.SNJ_WEB_SUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.PJP_WEB_SUBSCRIBE) && (
              <MyPreferenceSubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={phoneNumber}
                initialValues={this.initialValuesSubscribe}
                labels={labels}
                activeModal={activeModal}
              />
            )}
            {activeModal === MyPreferenceSubscriptionConstants.TCP_WEB_UNSUBSCRIBE && (
              <MyPreferenceUnsubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={smsPhone}
                labels={labels}
                activeModal={activeModal}
              />
            )}
            {activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_WEB_UNSUBSCRIBE && (
              <MyPreferenceUnsubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={gymSmsPhone}
                labels={labels}
                activeModal={activeModal}
              />
            )}
            {activeModal === MyPreferenceSubscriptionConstants.SNJ_WEB_UNSUBSCRIBE && (
              <MyPreferenceUnsubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={snjSmsPhone}
                labels={labels}
                activeModal={activeModal}
              />
            )}
            {activeModal === MyPreferenceSubscriptionConstants.PJP_WEB_UNSUBSCRIBE && (
              <MyPreferenceUnsubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={pjpSmsPhone}
                labels={labels}
                activeModal={activeModal}
              />
            )}

            {(activeModal === MyPreferenceSubscriptionConstants.TCP_APP_SUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_APP_SUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.SNJ_APP_SUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.PJP_APP_SUBSCRIBE) && (
              <MyPreferenceAppSubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={phoneNumber}
                initialValues={this.initialValuesSubscribe}
                labels={labels}
                activeModal={activeModal}
              />
            )}

            {(activeModal === MyPreferenceSubscriptionConstants.TCP_APP_UNSUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.GYMBOREE_APP_UNSUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.SNJ_APP_UNSUBSCRIBE ||
              activeModal === MyPreferenceSubscriptionConstants.PJP_APP_UNSUBSCRIBE) && (
              <MyPreferenceAppUnsubscribeModal
                onRequestClose={this.handlePopupSubscribeModal}
                onSubmit={this.handleSubmitModalPopup}
                phoneNumber={smsPhone || gymSmsPhone || snjSmsPhone || pjpSmsPhone}
                labels={labels}
                activeModal={activeModal}
              />
            )}
          </Modal>
        )}
      </>
    );
  }
}

export const mapStateToProps = (state, ownProps) => ({
  isTcpSubscribe: getTcpSubscribe(state),
  isTcpAppSubscribe: getTcpAppSubscribe(state),
  phoneNumber: getUserPhoneNumber(state),
  smsPhone: getSmsPhone(state),
  isGymSubscribe: getGymSubscribe(state),
  isSnjSubscribe: getSnjSubscribe(state),
  isGymAppSubscribe: getGymAppSubscribe(state),
  isSnjAppSubscribe: getSnjAppSubscribe(state),
  isPjpAppSubscribe: getPjpAppSubscribe(state),
  isPjpSubscribe: getPjpSubscribe(state),
  gymSmsPhone: getGymSmsPhone(state),
  snjSmsPhone: getSnjSmsPhone(state),
  pjpSmsPhone: getPjpSmsPhone(state),
  labels: {
    ...ownProps.labels,
  },
  isSnjPjpBrandCheckboxesDisabled: getIsSnjPjpCheckboxesDisabled(state),
  showNotification: getshowNotification(state),
  newGlobalErrorMessageEnabled: getNewGlobalErrorMessage(state),
  isErrorVisibleState: getErrorVisibleState(state),
});

export const mapDispatchToProps = (dispatch) => {
  return {
    getSubscribeStoreAction: () => {
      dispatch(getSubscribeStore());
    },
    submitSubscribeBrand: (payload) => {
      dispatch(setBrandSubscribeData(payload));
    },
    subscribeFailureResetAction: () => {
      dispatch(subscribeFailureReset());
    },
    trackSubscriptionEvent: (payload) => {
      dispatch(setClickAnalyticsData(payload));
      dispatch(trackClick());
      dispatch(setClickAnalyticsData({}));
    },
    setGlobalErrorAction: (payload) => {
      dispatch(setGlobalError(payload));
    },
  };
};

MyPreferenceSubscription.propTypes = {
  labels: PropTypes.shape({}),
  handleComponentChange: PropTypes.func,
  componentProps: PropTypes.shape({}),
  isTcpSubscribe: PropTypes.bool,
  isTcpAppSubscribe: PropTypes.bool,
  isGymSubscribe: PropTypes.bool,
  isSnjSubscribe: PropTypes.bool,
  isPjpSubscribe: PropTypes.bool,
  isGymAppSubscribe: PropTypes.bool,
  isPjpAppSubscribe: PropTypes.bool,
  getSubscribeStoreAction: PropTypes.func.isRequired,
  submitSubscribeBrand: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  smsPhone: PropTypes.string,
  gymSmsPhone: PropTypes.string,
  snjSmsPhone: PropTypes.string,
  pjpSmsPhone: PropTypes.string,
  router: PropTypes.shape({
    query: PropTypes.shape({}),
  }),
  trackSubscriptionEvent: PropTypes.func.isRequired,
  showNotification: PropTypes.bool,
};

MyPreferenceSubscription.defaultProps = {
  labels: {},
  handleComponentChange: () => {},
  componentProps: {},
  isTcpSubscribe: false,
  isTcpAppSubscribe: false,
  isGymAppSubscribe: false,
  isPjpAppSubscribe: false,
  isSnjSubscribe: false,
  isGymSubscribe: false,
  isPjpSubscribe: false,
  smsPhone: '',
  gymSmsPhone: '',
  snjSmsPhone: '',
  pjpSmsPhone: '',
  router: {},
  showNotification: false,
};

const withReducer = withDynamicReducer([
  {
    key: 'MyPreference',
    reducer: MyPreferenceSubscriptionReducer,
  },
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
]);
const withSaga = withDynamicSaga({ key: 'MyPreference', saga: SubscribeStoreSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(MyPreferenceSubscription);
